import axios from "axios";
import baseURL from "../configs/api";


export const sendQuoteEmailAPI = (primaryKey: number, cc: string, userId: number, tenantId: string) => {
    return getFetch(`QuoteEmail?quoteId=${primaryKey}&userId${userId}&ccEmail=${cc}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}